const locale = {
	enums: {
		TicketType: {
			ERROR_REPORT: 'Error report',
			FEEDBACK_AND_COMMENT: 'Feedback and comment',
			LICENSE: 'License',
			OTHERS: 'Others'
		},
		Priority: {
			LOW: 'Low',
			NORMAL: 'Normal',
			HIGH: 'High',
			CRITICAL: 'Critical'
		},
		TicketStatus: {
			REGISTERED: 'Registered',
			READ: 'Read',
			PENDING: 'Pending',
			ANSWERED: 'Answered',
			CLOSED: 'Closed'
		}
	},
	ticketCategories: {
		general: 'General',
		lineSegmentDetector: 'Line Segment Detector',
		arcLineDetector: 'ArcLine Detector',
		contrastEnhancement: 'Contrast Enhancement',
		denoising: 'Denoising',
		deblurring: 'Deblurring',
		deraining: 'Deraining',
		resolutionEnhancement: 'Resolution Enhancement',
		inpainting: 'Inpainting',
		objectDetection: 'Object Detection',
		countObjects: 'Count Objects',
		poseEstimation: 'Pose Estimation',
		faceDetection: 'Face Detection',
		deepLearning: 'Deep Learning',
		classificationAnnotation: 'Classification Annotation',
		boundingBoxAnnotation: 'Bounding Box Annotation',
		boundaryAnnotation: 'Boundary Annotation',
		faceRecognition: 'Face Recognition',
		anomalyDetection: 'Anomaly Detection',
		correctiveExercise: 'Corrective Exercise'
	},
	faqCategories: {
		paymentsBilling: 'Payments Billing',
		security: 'Security',
		account: 'Account'
	},
	tickets: {
		title: 'My Tickets',
		newTicket: 'New ticket',
		no: 'No',
		ticketType: 'Type',
		services: 'Services',
		priority: 'Priority',
		date: 'Date',
		subject: 'Subject',
		user: 'User',
		status: 'Status',
		detail: 'View details',
		delete: 'Delete',
		actions: 'Actions',
		noTickets: 'No tickets found.'
	},
	newTicket: {
		title: 'New Ticket',
		ticketType: 'Type',
		priority: 'Priority',
		services: 'Services',
		invalidSubjectLen: 'Up to 200 characters!',
		subject: 'Subject',
		message: 'Message',
		sendAlert: 'Notify me by email',
		attachment: 'Attachment',
		back: 'Back to My Tickets'
	},
	ticketDetails: {
		title: 'Ticket Details',
		send: 'Send',
		back: 'Back to My Tickets'
	},
	termsCondition: {
		title: 'Terms and Conditions',
		updatedAt: 'Last updated: April 2025',
		head1: 'Welcome to fraime!',
		paragraph1:
			'These terms and conditions outline the rules and regulations for the use of fraime\'s Website, located at <a href="https://saiwa.ai/fraime">www.saiwa.ai/fraime</a>.',
		paragraph2:
			'By accessing this website we assume you accept these terms and conditions. Do not continue to use fraime if you do not agree to take all of the terms and conditions stated on this page.',
		paragraph3:
			'The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company\'s terms and conditions."The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client\'s needs in respect of provision of the Company\'s stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/ or he/ she or they, are taken as interchangeable and therefore as referring to same.',
		head2: 'cookies',
		paragraph4:
			"We employ the use of cookies. By accessing fraime, you agreed to use cookies in agreement with the fraime's Privacy Policy.",
		paragraph5:
			"Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/ advertising partners may also use cookies.",
		head3: 'License',
		paragraph6:
			'Unless otherwise stated, fraime and/or its licensors own the intellectual property rights for all material on fraime.  All intellectual property rights are reserved. You may access this from fraime for your own personal use subjected to restrictions set in these terms and conditions.',
		paragraph7: 'You must not:',
		item1: 'Republish material from fraime',
		item2: 'Sell, rent or sub-license material from fraime',
		item3: 'Reproduce, duplicate or copy material from fraime',
		item4: 'Redistribute content from fraime',
		paragraph8:
			'This Agreement shall begin on the date hereof. Our Terms and Conditions were created with the help of the <a href="https://www.termsandconditionsgenerator.com">Terms And Conditions Generator</a> and the <a href="https://www.generateprivacypolicy.com">Privacy Policy Generator</a>.',
		paragraph9:
			'Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. fraime does not filter, edit, publish or review Comments prior to their presence on the website.Comments do not reflect the views and opinions of fraime, its agents and/ or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, fraime shall not be liable for the Comments or for any liability, damages or expenses caused and/ or suffered as a result of any use of and / or posting of and / or appearance of the Comments on this website.',
		paragraph10:
			'fraime reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.',
		paragraph11: 'You warrant and represent that:',
		item5:
			'You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;',
		item6:
			'The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;',
		item7:
			'The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy',
		item8:
			'The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.',
		paragraph12:
			'You hereby grant fraime a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.',
		head4: 'Hyperlinking to our Content',
		paragraph13: 'The following organizations may link to our Website without prior written approval:',
		item9: 'Government agencies;',
		item10: 'Search engines;',
		item11: 'News organizations;',
		item12:
			'Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and',
		item13:
			'System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.',
		paragraph14:
			"These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.",
		paragraph15: 'We may consider and approve other link requests from the following types of organizations:',
		item14: 'commonly-known consumer and/or business information sources;',
		item15: 'dot.com community sites;',
		item16: 'associations or other groups representing charities;',
		item17: 'online directory distributors;',
		item18: 'internet portals;',
		item19: 'accounting, law and consulting firms; and',
		item20: 'educational institutions and trade associations.',
		paragraph16:
			'We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of fraime; and (d) the link is in the context of general resource information.',
		paragraph17:
			"These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.",
		paragraph18:
			'If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to fraime. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.',
		paragraph19: 'Approved organizations may hyperlink to our Website as follows:',
		item21: 'By use of our corporate name; or',
		item22: 'By use of the uniform resource locator being linked to; or',
		item23:
			"By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site.",
		paragraph20:
			"No use of fraime's logo or other artwork will be allowed for linking absent a trademark license agreement.",
		head5: 'iFrames',
		paragraph21:
			'Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.',
		head6: 'Content Liability',
		paragraph22:
			'We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website.No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.',
		head7: 'Your Privacy',
		paragraph23: 'Please read ',
		paragraph24: 'Privacy Policy',
		head8: 'Reservation of Rights',
		paragraph25:
			"We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it's linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.",
		head9: 'Removal of links from our website',
		paragraph26:
			'If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.',
		paragraph27:
			'We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.',
		head10: 'Disclaimer',
		paragraph28:
			'To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:',
		item24: 'limit or exclude our or your liability for death or personal injury;',
		item25: 'limit or exclude our or your liability for fraud or fraudulent misrepresentation;',
		item26: 'limit any of our or your liabilities in any way that is not permitted under applicable law; or',
		item27: 'exclude any of our or your liabilities that may not be excluded under applicable law.',
		paragraph29:
			'The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.',
		paragraph30:
			'As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.',
		exactLastUpdate: 'These terms were last updated on April 22, 2025 and are subject to change.'
	},
	privacyPolicy: {
		title: 'Privacy Policy',
		head1: 'Privacy Policy for fraime',
		updatedAt: 'Last updated: April 2025',
		paragraph1:
			'At fraime, accessible from <a href="https://saiwa.ai/fraime">saiwa.ai/fraime</a>, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by fraime and how we use it.',
		paragraph2:
			'If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.',
		paragraph3:
			'This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in fraime. This policy is not applicable to any information collected offline or via channels other than this website. Our Privacy Policy was created with the help of the <a href="https://www.privacypolicygenerator.info/">Privacy Policy Generator</a>.',
		head2: 'Consent',
		paragraph4: 'By using our website, you hereby consent to our Privacy Policy and agree to its terms.',
		head3: 'Information we collect',
		paragraph5:
			'The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.',
		paragraph6:
			'If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.',
		paragraph7:
			'When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.',
		head4: 'How we use your information',
		paragraph8: 'We use the information we collect in various ways, including to:',
		item1: 'Provide, operate, and maintain our website',
		item2: 'Improve, personalize, and expand our website',
		item3: 'Understand and analyze how you use our website',
		item4: 'Develop new products, services, features, and functionality',
		item5:
			'Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes',
		item6: 'Send you emails',
		item7: 'Find and prevent fraud',
		head5: 'Log Files',
		paragraph9:
			"fraime follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.",
		head6: 'Cookies and Web Beacons',
		paragraph10:
			"Like any other website, fraime uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.",
		paragraph11:
			'For more general information on cookies, please read <a href="https://www.privacypolicyonline.com/what-are-cookies/">"What Are Cookies"</a>.',
		head7: 'Advertising Partners Privacy Policies',
		paragraph12: 'You may consult this list to find the Privacy Policy for each of the advertising partners of fraime.',
		paragraph13:
			"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on fraime, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.",
		paragraph14:
			'Note that fraime has no access to or control over these cookies that are used by third-party advertisers.',
		head8: 'Third Party Privacy Policies',
		paragraph15:
			"fraime's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.",
		paragraph16:
			"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.",
		head9: 'CCPA Privacy Rights (Do Not Sell My Personal Information)',
		paragraph17: 'Under the CCPA, among other rights, California consumers have the right to:',
		paragraph18:
			"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.",
		paragraph19: 'Request that a business delete any personal data about the consumer that a business has collected.',
		paragraph20:
			"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.",
		paragraph21:
			'If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.',
		head10: 'GDPR Data Protection Rights',
		paragraph22:
			'We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:',
		paragraph23:
			'The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.',
		paragraph24:
			'The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.',
		paragraph25:
			'The right to erasure – You have the right to request that we erase your personal data, under certain conditions.',
		paragraph26:
			'The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.',
		paragraph27:
			'The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.',
		paragraph28:
			'The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.',
		paragraph29:
			'If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.',
		head11: "Children's Information",
		paragraph30:
			'Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.',
		paragraph31:
			'fraime does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.',
		head12: 'These policies were last updated on April 22, 2025 and are subject to change.'
	},
	faq: {
		title: 'Frequently asked questions',
		subTitle: "We're here to help",
		search: 'Search in faqs...',
		noFaqs: 'There are no faqs!'
	},
	common: {
		generalError: 'Oops! Something went wrong! <br />Help us improve your experience by sending an ',
		errorTicket: 'error ticket...',
		required: 'This field is required',
		upload: 'Upload',
		successfulSave: 'Saved successfully',
		successfulDelete: 'Deleted successfully',
		done: 'Done',
		cancel: 'Cancel',
		send: 'Send',
		confirmationTitle: 'Confirmation',
		confirmationMessage: 'Are you sure you want to delete this record?'
	},
	tablePagination: {
		labelRowsPerPage: 'Rows per page:',
		labelDisplayedRows: 'of'
	}
};

export default locale;
